export const DEVICE_TYPE_SWITCH = 1;
export const DEVICE_TYPE_FIREWALL = 2;
